import { FETCH_ALLOC_EMP } from "../actions/AdminActions";
import { DOWN_ORDER_SUCCESS_ACTION, DOWN_PREFS_ADMIN_SUCCESS_ACTION, DOWN_PREFS_SUCCESS_ACTION, FETCH_CATEGORY_FAILED_ACTION, FETCH_CATEGORY_SUCCESS_ACTION, FETCH_DISTRICT_SUCCESS_ACTION, FETCH_POST_SUCCESS_ACTION, FETCH_PREFS_SUCCESS_ACTION, FETCH_REG_STATUS_ACTION, FETCH_USER_SUCCESS_ACTION, SAVE_PREF_STATUS_ACTION, SEND_OTP_ACTION, SEND_OTP_FAILED_ACTION } from "../actions/PreferencesActions";

const initialState = {
    category:[],
    errorMessage:'',
    districts:[],
    preferences:{}
}
export function PreferenceReducer(state = initialState, action) {
    
    if(action.type === FETCH_CATEGORY_SUCCESS_ACTION){
        return {
            ...state,
            category:action.payload
        }
    }
    else if(action.type === FETCH_CATEGORY_FAILED_ACTION){
        return {
            ...state,
            errorMessage:action.payload
        }
    }
    else if(action.type === FETCH_DISTRICT_SUCCESS_ACTION){
        return {
            ...state,
            districts:action.payload.data,
            status:action.payload.status,
        }
    }
    else if(action.type === FETCH_POST_SUCCESS_ACTION){
        return {
            ...state,
            posts:action.payload
        }
    }
    else if(action.type === FETCH_PREFS_SUCCESS_ACTION){
        return {
            ...state,
            preferences:action.payload,
        }
    }
    else if(action.type === FETCH_REG_STATUS_ACTION){
        return {
            ...state,
            status:action.payload,
        }
    }
    else if(action.type === SEND_OTP_ACTION){
        return {
            ...state,
            sendOTP:action.payload,
        }
    }
    else if(action.type === SEND_OTP_FAILED_ACTION){
        return {
            ...state,
            sendOTP:action.payload,
        }
    }
    else if(action.type === SAVE_PREF_STATUS_ACTION){
        return {
            ...state,
            sendOTP:action.payload,
        }
    }
    else if(action.type === DOWN_PREFS_SUCCESS_ACTION){
        return {
            ...state,
            downPref:action.payload,
        }
    }
    else if(action.type === DOWN_PREFS_ADMIN_SUCCESS_ACTION){
        return {
            ...state,
            downPrefAdmin:action.payload,
        }
    }
    else if(action.type === FETCH_ALLOC_EMP){
        return {
            ...state,
            allocation:action.payload,
        }
    }
    else if(action.type === DOWN_ORDER_SUCCESS_ACTION){
        return {
            ...state,
            order:action.payload,
        }
    }
    if(action.type === 'PREF RESET'){
        return {
            ...state,
            resetPref:action.payload,
            sendOTP:false
        }
    }
    return state;
}
